export class RepairSupplier {
  repairSupplierIsn: number;
  fedexSupplierCode: string;
  companyName: string;
  companyPartNumber: string;
  manufacturersPartNumber: string;
  priorityIndicator: number;
  repairFixNteIndicator: string;
  overhaulFixNteIndicator: string;
  leadTime: number;
  contractNumber: string;
  inHouseFlag: string;
  shopStationDepartment: string;
  buyerId: string;
  repairCapacity: string;
  marketValue: number;
  newUnitCost: number;
  requestNumber: number;
  modificationTime: number;
  modificationCost: number;
  exchangeCost: number;
  averageMtbur: number;
  averageMtbf: number;
  processMethod: string;
  effectiveDate: Date;
  contractEffectiveDate: Date;
  contractExpirationDate: Date;
  repairSpecOverride: string;
  termsDiscount: string;
  averageRepairCost: number;
  serviceOrderCount: number;
  activeContractIndicator: number;
  serviceOrderEmailAddress: string;
  allTypeSuspendedIndicator: number;
  purchaseOrderSuspendedIndicator: number;
  serviceOrderSuspendedIndicator: number;
  nullPoSoSuspendedIndicator: number;
  allSuspendedSupplierTypes: string;
  purchaseOrderSuspendedSupplierTypes: string;
  serviceOrderSuspendedSupplierTypes: string;
  nullPoSoSuspendedSupplierTypes: string;
  authorizedUncheckedCount: number;
  authorizedUncheckedSupplierTypes: string;
  authorizedCheckedCount: number;
  authorizedCheckedSupplierTypes: string;
}
